var angular = require('angular');
var tpl = require('./inline.html');

var amt_from_inline = {
    template: tpl,
    bindings: {
        name: "@",
        schemaForm: '<',
        extendModel: '<',
        onSubmit: "&",
        onChange: "&"
    },
    controller: ['jsonrpc', '$rootScope', '$location', function (jsonrpc, $rootScope, $location) {
        this.display = false;
        this.schema = undefined;
        this.form = undefined;
        this.model = {};
        this.helpers = {
            countries: []
        };

        var self = this;

        // This is temporary solution ***
        var setToGlobal = function(params){
            if (!$location.search().filters){
                var _context = {};
                angular.forEach(params, function (value, key) {
                    if (key.indexOf('_') !== 0){
                        this[key] = value.default;
                        $rootScope.chartParams.filters[key] = value.default;
                    }
                }, _context);
                //
            }
        };
        // *** tmp

        this.$onInit = function () {
            if(!this.schemaForm){
                var api_service = this.name.split('.')[0];
                var api_method = this.name.split('.')[1];
                var FormsApiService = jsonrpc.newService(api_service).createMethod(api_method);

                FormsApiService({
                    action: 'get',
                    params: {},
                    model: {}
                })
                .then(function (resp) {
                    self.schemaForm = resp;
                    self.schema = resp.schema;
                    self.form = resp.form;
                    self.model = angular.extend({
                        _timezone_offset: new Date().getTimezoneOffset() / 60
                    }, resp.model, self.extendModel || {});
                    self.display = true;
                    setToGlobal(self.schema.properties); // tmp
                })
            }else{
                this.schema = this.schemaForm.schema;
                this.form = this.schemaForm.form;
                this.model = angular.extend({
                    _timezone_offset: new Date().getTimezoneOffset() / 60
                }, this.schemaForm.model, this.extendModel || {});
                this.display = true;
            }
        };
    }]

};

export default function (app) {
    app.component('amtFormInline', amt_from_inline)
};
